var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_419_760)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_419_760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.67554,
    y: 0.978149,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_419_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6255 18.9781C14.9755 18.9781 15.2714 18.8573 15.513 18.6156C15.7547 18.374 15.8755 18.0781 15.8755 17.7281C15.8755 17.3781 15.7547 17.0823 15.513 16.8406C15.2714 16.599 14.9755 16.4781 14.6255 16.4781C14.2755 16.4781 13.9797 16.599 13.738 16.8406C13.4964 17.0823 13.3755 17.3781 13.3755 17.7281C13.3755 18.0781 13.4964 18.374 13.738 18.6156C13.9797 18.8573 14.2755 18.9781 14.6255 18.9781ZM13.7255 15.1281H15.5755C15.5755 14.5781 15.638 14.1448 15.763 13.8281C15.888 13.5115 16.2422 13.0781 16.8255 12.5281C17.2589 12.0948 17.6005 11.6823 17.8505 11.2906C18.1005 10.899 18.2255 10.4281 18.2255 9.87815C18.2255 8.94482 17.8839 8.22815 17.2005 7.72815C16.5172 7.22815 15.7089 6.97815 14.7755 6.97815C13.8255 6.97815 13.0547 7.22815 12.463 7.72815C11.8714 8.22815 11.4589 8.82815 11.2255 9.52815L12.8755 10.1781C12.9589 9.87815 13.1464 9.55315 13.438 9.20315C13.7297 8.85315 14.1755 8.67815 14.7755 8.67815C15.3089 8.67815 15.7089 8.82398 15.9755 9.11565C16.2422 9.40732 16.3755 9.72815 16.3755 10.0781C16.3755 10.4115 16.2755 10.724 16.0755 11.0156C15.8755 11.3073 15.6255 11.5781 15.3255 11.8281C14.5922 12.4781 14.1422 12.9698 13.9755 13.3031C13.8089 13.6365 13.7255 14.2448 13.7255 15.1281ZM14.6755 22.9781C13.2922 22.9781 11.9922 22.7156 10.7755 22.1906C9.55887 21.6656 8.50054 20.9532 7.60054 20.0532C6.70054 19.1532 5.98804 18.0948 5.46304 16.8781C4.93804 15.6615 4.67554 14.3615 4.67554 12.9781C4.67554 11.5948 4.93804 10.2948 5.46304 9.07815C5.98804 7.86148 6.70054 6.80315 7.60054 5.90315C8.50054 5.00315 9.55887 4.29065 10.7755 3.76565C11.9922 3.24065 13.2922 2.97815 14.6755 2.97815C16.0589 2.97815 17.3589 3.24065 18.5755 3.76565C19.7922 4.29065 20.8505 5.00315 21.7505 5.90315C22.6505 6.80315 23.363 7.86148 23.888 9.07815C24.413 10.2948 24.6755 11.5948 24.6755 12.9781C24.6755 14.3615 24.413 15.6615 23.888 16.8781C23.363 18.0948 22.6505 19.1532 21.7505 20.0532C20.8505 20.9532 19.7922 21.6656 18.5755 22.1906C17.3589 22.7156 16.0589 22.9781 14.6755 22.9781ZM14.6755 20.9781C16.9089 20.9781 18.8005 20.2031 20.3505 18.6531C21.9005 17.1031 22.6755 15.2115 22.6755 12.9781C22.6755 10.7448 21.9005 8.85315 20.3505 7.30315C18.8005 5.75315 16.9089 4.97815 14.6755 4.97815C12.4422 4.97815 10.5505 5.75315 9.00054 7.30315C7.45054 8.85315 6.67554 10.7448 6.67554 12.9781C6.67554 15.2115 7.45054 17.1031 9.00054 18.6531C10.5505 20.2031 12.4422 20.9781 14.6755 20.9781Z",
    fill: "#FFFBF1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_419_760",
    x: 0.675537,
    y: 0.978149,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_419_760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_419_760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBox);
export default __webpack_public_path__ + "static/media/helpBox.4e822a6c359f81a86487bd67107b9de4.svg";
export { ForwardRef as ReactComponent };